import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useInterval } from 'react-use';
import { Counter } from 'models.market';

export interface ICounterExpiry {
  counter: Counter;
}

const UPDATE_INTERVAL = 20000;

export default function CounterExpiry({ counter }: ICounterExpiry) {
  const [now, setNow] = useState(dayjs());
  useInterval(() => setNow(dayjs()), UPDATE_INTERVAL);

  const expiryAt = dayjs(counter.expiry);
  const expiryIn = dayjs.duration(expiryAt.diff(now));

  return (
    <div className="icon-clock expiry">
      {expiryAt.isBefore(now) ? 'Expired' : 'Expires'} on{' '}
      {expiryAt.format('LLL')} ({expiryIn.humanize(true)})
    </div>
  );
}
